import React from "react";
import { Link as RouterLink } from "react-router-dom";
import { Box, Paper, Typography, Button } from "@mui/material";
import { alpha } from "@mui/material/styles";
import HourglassTopIcon from "@mui/icons-material/HourglassTop";
import { brand, shadow } from "../../theme/tokens";

const PendingPage = () => (
  <Box
    sx={{
      minHeight: "100dvh",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      p: 2,
      backgroundImage: `linear-gradient(135deg, ${brand.purpleDeep} 0%, ${brand.purple} 100%)`,
    }}
  >
    <Paper
      elevation={0}
      sx={{
        width: "100%",
        maxWidth: 460,
        p: { xs: 3, sm: 5 },
        borderRadius: 4,
        backgroundColor: "background.paper",
        textAlign: "center",
        boxShadow: shadow.overlay,
      }}
    >
      <Box
        sx={{
          width: 72,
          height: 72,
          borderRadius: "50%",
          backgroundColor: alpha(brand.amber, 0.13),
          color: brand.amber,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          mx: "auto",
          mb: 2,
        }}
      >
        <HourglassTopIcon sx={{ fontSize: 40 }} />
      </Box>
      <Typography variant="h5" sx={{ fontWeight: 700, color: "secondary.main", mb: 1 }}>
        Awaiting approval
      </Typography>
      <Typography variant="body1" sx={{ color: "text.secondary", mb: 3 }}>
        Your registration has been received. A platform administrator needs to
        approve your organization before you can sign in. You'll be able to log
        in as soon as your account is activated.
      </Typography>
      <Button
        component={RouterLink}
        to="/login"
        variant="contained"
        color="secondary"
      >
        Back to sign in
      </Button>
    </Paper>
  </Box>
);

export default PendingPage;
